import React from 'react';
import cx from 'clsx';
import { ColorPicker as AntdColorPicker, Flex } from 'antd';
import Label from '../label/Label';
import ErrorMessage from '../error-message/ErrorMessage';
import styles from './ColorPicker.module.scss';
import clsx from 'clsx';

const ColorPicker = ({
  containerClassName = '',
  defaultValue = '',
  value = '',
  placeholder = '',
  label = '',
  labelClassName = '',
  required = false,
  errorMsg = '',
  disabled = false,
  onChange = () => {},
  size = 'medium',
  className = '',
  ...props
}) => {
  return (
    <div className={cx('d-flex flex-column', containerClassName)}>
      {label && (
        <Label className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      <AntdColorPicker
        defaultValue={defaultValue}
        value={value}
        disabled={disabled}
        onChange={onChange}
        size={size}
        allowClear
        {...props}
      >
        <Flex className={clsx(styles.itemContainer, className)} gap={12} align="center">
          <div className={styles.color} style={{ backgroundColor: value }} />
          <div className="body-regular">{value || ''}</div>
        </Flex>
      </AntdColorPicker>
      {errorMsg && <ErrorMessage errorMessage={errorMsg} />}
    </div>
  );
};

export default ColorPicker;
